// Small presentation helpers shared across components.

export function capitalise(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// First-name extraction from the JWT `name` claim (Phase 0.2), for the
// Maeve-First greeting/personalisation across every surface (HR dashboard,
// Manager dashboard/mobile/welcome, Employee portal/mobile). Empty string on
// a missing/empty claim (pre-Phase-0.2 token, or a nameless invite) — the
// fallback is always a neutral, anti-anthropomorphism-safe greeting, never a
// thrown error.
export function firstNameFromSession(session: { name?: string }): string {
  return session.name?.split(' ')[0] ?? '';
}

// Join preference fragments into one human sentence ("a · b · c."), or null
// when there are none. Used by the manager's contact-preference hint and the
// case-detail per-touch-point preference summary so they phrase identically.
export function prefSentence(parts: readonly string[]): string | null {
  if (parts.length === 0) return null;
  return `${capitalise(parts.join(' · '))}.`;
}

// Used by HR's and the Manager's Policies list so a file's size renders
// identically on both surfaces.
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

// Used by HR's and the Manager's Policies list so an upload date renders
// identically on both surfaces.
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
